export const permissionsByProductType: Readonly<Record<number, readonly string[]>> = {
  1: [
    'product:package',
    'product:hot',
    'product:superior',
    'product:zhongying',
    'product:district',
    'product:course',
    'product:star',
    'product:gift',
    'order:package',
    'order:hot',
    'order:superior',
    'order:district',
    'order:course',
    'order:star',
    'order:gift',
    'order:send-more',
    'order:after-sales',
    'assets:read',
    'settings:password',
  ],
  2: [
    'product:superior',
    'product:zhongying',
    'product:district',
    'order:superior',
    'order:district',
    'order:after-sales',
    'assets:read',
    'settings:password',
  ],
}

export function permissionsFor(productType?: number): string[] {
  return productType ? [...(permissionsByProductType[productType] ?? [])] : []
}
